import type { ChatStreamBodyMessagesItemRole } from './chatStreamBodyMessagesItemRole';

export type ChatStreamBodyMessagesItem = {
  /** 메시지 내용 */
  content: string;
  /** 메시지 역할 */
  role: ChatStreamBodyMessagesItemRole;
};
